import React from 'react';
import { ArrowRightIcon, XIcon } from 'lucide-react';
import { Eyebrow, Section } from './Shared';
import { Bagua, LeafSpray } from './Decor';
import { painPoints, transformationList } from '../data/pack';
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-304" data-mp="26y603q80qweu">
      {/* Sección problema */}
      <div className="relative overflow-hidden border border-brand-cinnabar/30 bg-brand-cinnabarMist/60 p-6 md:p-10" data-id="element-305" data-mp="2bwhac22878xl">
        <div className="mx-auto mb-8 max-w-2xl text-center" data-id="element-306" data-mp="1xw6iavp6joau">
          <Eyebrow data-id="element-307" data-mp="21zur1hpjspxo">El punto de partida</Eyebrow>
          <h2 className="mt-3 font-title text-2xl leading-tight text-brand-cinnabarDark md:text-4xl" data-id="element-308" data-mp="220o22uvji1lm">
            Lo que pasa cuando no sabés qué está bloqueando tu espacio
          </h2>
          <div className="double-rule mx-auto mt-5 w-20" aria-hidden="true" data-id="element-309" data-mp="1sz6mddm1o1xg" />
        </div>

        <ul className="grid gap-4 sm:grid-cols-2" data-id="element-310" data-mp="3iewalljh6ae9">
          {painPoints.map(point => <li key={point.quote} className="border-l-4 border-brand-cinnabar bg-brand-paper p-5" data-id="element-311" data-mp="3ncxv8awjuhru">
              <p className="flex items-start gap-2.5 font-serif text-sm font-semibold italic text-brand-ink md:text-base" data-id="element-312" data-mp="1yzvgfasdabqr">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-brand-cinnabar" aria-hidden="true" data-id="element-313" data-mp="1u12f0gqcub6y" />
                “{point.quote}”
              </p>
              <p className="mt-2 flex items-start gap-2 pl-6 text-sm leading-relaxed text-brand-muted" data-id="element-314" data-mp="23rdm2c5c50i2">
                <ArrowRightIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-wood" aria-hidden="true" data-id="element-315" data-mp="1g1j5pklt4tt2" />
                {point.result}
              </p>
            </li>)}
        </ul>
      </div>

      {/* Sección transformación */}
      <div className="relative mt-14 overflow-hidden border-2 border-brand-gold bg-brand-paper p-8 md:p-12" data-id="element-316" data-mp="1p3k62qcc7vyy">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-317" data-mp="1k1upywa9cs40">
          <Bagua className="absolute -right-16 -top-16 h-64 w-64 text-brand-jade/10" data-id="element-318" data-mp="30g30ttlo1czt" />
          <LeafSpray className="absolute -bottom-8 -left-8 hidden h-44 w-44 text-brand-jade/12 md:block" data-id="element-319" data-mp="2vhjgfxmq099k" />
        </div>

        <div className="relative text-center" data-id="element-320" data-mp="1t4vjkhs28kp7">
          <h3 className="mx-auto max-w-2xl font-title text-2xl leading-tight text-brand-jadeDeep md:text-4xl" data-id="element-321" data-mp="1y3zv3f2giuip">
            ¿Y si esta fuera la última vez que mirás tu negocio sin saber qué cambiar?
          </h3>
          <div className="double-rule mx-auto mt-6 w-20" aria-hidden="true" data-id="element-322" data-mp="2756b7n1723bf" />

          <p className="mx-auto mt-7 max-w-2xl font-serif text-base text-brand-inkLight md:text-lg" data-id="element-323" data-mp="1aexbi1o9irlk">
            Imaginá entrar mañana y poder detectar rápidamente:
          </p>
          <ul className="mx-auto mt-5 grid max-w-2xl gap-2 text-left sm:grid-cols-2" data-id="element-324" data-mp="1edwdpeim0a9b">
            {transformationList.map(item => <li key={item} className="flex items-start gap-2.5 font-serif text-sm text-brand-ink md:text-base" data-id="element-325" data-mp="1o5se4w864cgp">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-jade" aria-hidden="true" data-id="element-326" data-mp="qr7pkb30blk9" />
                {item}
              </li>)}
          </ul>

          <div className="mx-auto mt-8 max-w-2xl space-y-3 font-serif text-base leading-relaxed text-brand-inkLight md:text-lg" data-id="element-327" data-mp="vnepnn8q22ua">
            <p data-id="element-328" data-mp="j6nh2vc033af">Imaginá tener un sistema donde cada paso está explicado visualmente y listo para aplicar.</p>
            <p className="font-title text-lg not-italic text-brand-cinnabar md:text-xl" data-id="element-329" data-mp="e7arw3xnpk4o">
              Eso es exactamente lo que vas a tener con este pack.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}